import React from "react";
import { CommunicationInfoContainer } from "../../../containers";

const CommunicationInfo = (props) => {
  return <CommunicationInfoContainer {...props} />;
};

export default CommunicationInfo;
